import { styled } from "@mui/material/styles";
import { BaseButton } from "components/button/base";
import AppStoreImageAsset from "assets/images/app-store.svg";
import GooglePlayImageAsset from "assets/images/google-play.svg";

export const AppStoreImage = styled(AppStoreImageAsset, {
  label: "app-store-image",
})`
  display: block;
  max-width: 100%;
  width: auto;
  height: ${({ theme }) => theme.spacing(5)};
`;

export const GooglePlayImage = styled(GooglePlayImageAsset, {
  label: "google-play-image",
})`
  display: block;
  max-width: 100%;
  width: auto;
  height: ${({ theme }) => theme.spacing(5)};
`;

export const ContainerExp = styled("div", {
  label: "download",
})`
  text-align: center;

  ${({ theme }) => theme.breakpoints.up("md")} {
    text-align: inherit;
  }
`;

export const Link = styled(BaseButton, {
  label: "link",
})`
  & + & {
    margin-left: ${({ theme }) => theme.spacing(1.5)};
  }
`;

export const LinksExp = styled("div", {
  label: "links",
})`
  display: flex;
  justify-content: center;

  ${({ theme }) => theme.breakpoints.up("md")} {
    justify-content: flex-start;
  }
`;
